export default __webpack_public_path__ + "static/media/goGreenBg.5bcaa222.svg";